module.exports = __webpack_public_path__ + "img/toubu.b8bad1be.png";